export default "__VITE_ASSET__DEyEzgTY__"